// extracted by mini-css-extract-plugin
export default {"title-wrapper":"styles__title-wrapper--B0kM4"};